import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateIotAgentVersion } from "./updateIotAgentSlice";
import { fetchOrganizationData } from "../../../pages/users/listOrganizationSlice";
import useNotification from "../../notification/useNotification";
import { isSuccessResponse } from "../../../common/utils";
import { selector as updateversion, setShow } from "./updateIotAgentSlice";
import { selector as iotAgentApi } from "../../../pages/manageUpdates/iotAgentSlice";
import { FILE_TYPE } from "../../../common/constants";
import { IListIotAgent } from "../../../common/types/iotAgentTypes";
import { Row } from "@tanstack/react-table";

interface IUpdatePayload {
    orgId: string;
    fileName: string;
    fileType: string;
    version: string;
}

interface IRow {
    name: string;
    timestamp: string;
    version: string;
    _id: string;
}

export function useUpdateIotAgent() {
    const dispatch: any = useDispatch();
    const [selectedRows, setSelectedRows] = useState<IRow[]>([]);

    const show: boolean = useSelector(updateversion)?.show;
    const orgId: string = useSelector(updateversion)?.orgId;
    const row: IListIotAgent = useSelector(iotAgentApi);
    const isDisabled = (selectedRows.length <= 0);

    const onRowSelectionChange = useCallback(
        (row: Row<IRow>) => (event: React.ChangeEvent<HTMLInputElement>) => {
            row.getToggleSelectedHandler()(event);
            if (!row.getIsSelected()) {
                setSelectedRows([row.original]);
            } else {
                setSelectedRows([]);
            }
        },
        [],
    );

    const { showSuccessNotification, showWarningNotification } = useNotification();

    const handleClose = useCallback(() => {
        dispatch(setShow(!show));
    }, []);

    const handleUpdate = () => {
        const updatePayload: IUpdatePayload = {
            orgId: orgId,
            fileName: selectedRows[0].name,
            fileType: FILE_TYPE.IOT_AGENT,
            version: selectedRows[0].version,
        };
        dispatch(setShow(false));
        dispatch(updateIotAgentVersion(updatePayload)).then((response) => {
            if (isSuccessResponse(response.payload)) {
                dispatch(fetchOrganizationData());
                showSuccessNotification(response.payload.message);
            }
            else {
                showWarningNotification(response.payload.response.data.message);
            }
        });
    }

    return {
        show,
        handleClose,
        handleUpdate,
        onRowSelectionChange,
        selectedRows,
        row,
        isDisabled
    }

}